(function () {
  if (window.__rebloQuiz) return;
  window.__rebloQuiz = true;

  var KEYS = ['n', 'r', 'e', 's'];

  function init(section) {
    if (!section || section.__quizInit) return;
    section.__quizInit = true;

    var start      = section.querySelector('[data-quiz-start]');
    var startBtn   = section.querySelector('[data-quiz-startbtn]');
    var progress   = section.querySelector('[data-quiz-progress]');
    var progLabel  = section.querySelector('[data-quiz-progress-label]');
    var progBar    = section.querySelector('[data-quiz-progress-bar]');
    var progWrap   = section.querySelector('[data-quiz-progress-bar-wrap]');
    var questions  = Array.prototype.slice.call(section.querySelectorAll('[data-quiz-question]'));
    var nav        = section.querySelector('[data-quiz-nav]');
    var backBtn    = section.querySelector('[data-quiz-back]');
    var nextBtn    = section.querySelector('[data-quiz-next]');
    var nextLabel  = section.querySelector('[data-quiz-next-label]');
    var resultsBox = section.querySelector('[data-quiz-results]');
    var results    = Array.prototype.slice.call(section.querySelectorAll('[data-quiz-result]'));
    var email      = section.querySelector('[data-quiz-email]');
    var restartWrap= section.querySelector('[data-quiz-restart-wrap]');
    var restartBtn = section.querySelector('[data-quiz-restart]');

    // Progressive enhancement: nothing to step through without questions/results.
    if (!questions.length || !results.length) return;

    var total = questions.length;
    var current = 0;            // index into questions
    var started = false;

    var progTpl = section.getAttribute('data-progress-template') || '__CURRENT__ / __TOTAL__';
    var seeResultLabel = section.getAttribute('data-see-result') || 'Zobacz wynik';
    var nextDefaultLabel = section.getAttribute('data-next-label') || (nextLabel ? nextLabel.textContent : 'Dalej');

    // Worker integration: /quiz-plan sends the 7-day plan e-mail, /quiz-event
    // counts the funnel (start / complete). Blank endpoint = plain newsletter.
    var planEndpoint = section.getAttribute('data-plan-endpoint') || '';
    var eventsEndpoint = planEndpoint ? planEndpoint.replace(/quiz-plan\/?$/, 'quiz-event') : '';
    var planSuccessMsg = section.getAttribute('data-plan-success') || 'Gotowe! Sprawdź skrzynkę.';
    var planErrorMsg = section.getAttribute('data-plan-error') || 'Coś poszło nie tak. Spróbuj ponownie.';
    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    var lastWinner = null;

    function track(type, pattern) {
      if (!eventsEndpoint || inEditor) return;
      try {
        fetch(eventsEndpoint, {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ type: type, pattern: pattern || undefined })
        }).catch(function () {});
      } catch (_) {}
    }

    function show(el) { if (el) el.hidden = false; }
    function hide(el) { if (el) el.hidden = true; }

    // --- Initial (JS-on) state: collapse to intro only ---------------------
    questions.forEach(function (q) { q.style.display = 'none'; });
    if (resultsBox) resultsBox.style.display = 'none';
    show(start);
    hide(progress);
    hide(nav);
    if (restartWrap) hide(restartWrap);

    function setProgress() {
      var human = current + 1;
      if (progLabel) {
        progLabel.textContent = progTpl
          .replace('__CURRENT__', human)
          .replace('__TOTAL__', total);
      }
      if (progBar) progBar.style.width = (human / total * 100) + '%';
      if (progWrap) progWrap.setAttribute('aria-valuenow', String(human));
    }

    function selectedKey(q) {
      var checked = q.querySelector('[data-quiz-radio]:checked');
      return checked ? checked.value : null;
    }

    function refreshNext() {
      if (!nextBtn) return;
      var hasAnswer = !!selectedKey(questions[current]);
      nextBtn.disabled = !hasAnswer;
      var isLast = current === total - 1;
      if (nextLabel) nextLabel.textContent = isLast ? seeResultLabel : nextDefaultLabel;
    }

    function showQuestion(i, focus) {
      current = Math.max(0, Math.min(i, total - 1));
      questions.forEach(function (q, idx) {
        q.style.display = (idx === current) ? '' : 'none';
      });
      if (backBtn) backBtn.disabled = current === 0;
      setProgress();
      refreshNext();
      if (focus) {
        var legend = questions[current].querySelector('.quiz-q-text') ||
                     questions[current].querySelector('input');
        if (legend && legend.focus) {
          try { legend.setAttribute('tabindex', '-1'); legend.focus(); } catch (_) {}
        }
      }
    }

    function tally() {
      var counts = { n: 0, r: 0, e: 0, s: 0 };
      questions.forEach(function (q) {
        var k = selectedKey(q);
        if (k && counts.hasOwnProperty(k)) counts[k]++;
      });
      // Dominant key; ties resolved by KEYS order (n, r, e, s).
      var best = KEYS[0], bestVal = -1;
      KEYS.forEach(function (k) {
        if (counts[k] > bestVal) { bestVal = counts[k]; best = k; }
      });
      return best;
    }

    function showResults() {
      var winner = tally();
      lastWinner = winner;
      track('complete', winner);
      hide(progress);
      hide(nav);
      questions.forEach(function (q) { q.style.display = 'none'; });
      if (resultsBox) resultsBox.style.display = '';
      var matched = null;
      results.forEach(function (r) {
        var isMatch = r.getAttribute('data-key') === winner;
        r.style.display = isMatch ? '' : 'none';
        if (isMatch) matched = r;
      });
      // Fallback: if no result matches the winning key, show the first.
      if (!matched && results[0]) { results[0].style.display = ''; matched = results[0]; }
      if (email) email.style.display = '';
      if (restartWrap) { show(restartWrap); restartWrap.style.display = ''; }
      hide(start);
      if (matched && matched.focus) {
        var h = matched.querySelector('.quiz-result-title') || matched;
        try { h.setAttribute('tabindex', '-1'); h.focus(); } catch (_) {}
      }
      if (resultsBox) {
        try { resultsBox.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (_) {
          resultsBox.scrollIntoView();
        }
      }
    }

    function startQuiz() {
      started = true;
      track('start');
      hide(start);
      show(progress);
      show(nav);
      if (resultsBox) resultsBox.style.display = 'none';
      showQuestion(0, true);
    }

    function restart() {
      questions.forEach(function (q) {
        Array.prototype.forEach.call(q.querySelectorAll('[data-quiz-radio]'), function (c) { c.checked = false; });
        Array.prototype.forEach.call(q.querySelectorAll('.quiz-option'), function (o) { o.classList.remove('is-selected'); });
      });
      if (resultsBox) resultsBox.style.display = 'none';
      results.forEach(function (r) { r.style.display = ''; });
      if (restartWrap) hide(restartWrap);
      startQuiz();
    }

    // --- Wire option selection (reflect selected state for non :has browsers) ---
    section.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches('[data-quiz-radio]')) return;
      var q = e.target.closest('[data-quiz-question]');
      if (q) {
        Array.prototype.forEach.call(q.querySelectorAll('.quiz-option'), function (o) {
          var input = o.querySelector('[data-quiz-radio]');
          o.classList.toggle('is-selected', !!(input && input.checked));
        });
      }
      if (started) refreshNext();
    });

    if (startBtn) startBtn.addEventListener('click', startQuiz);
    if (backBtn) backBtn.addEventListener('click', function () {
      if (current > 0) showQuestion(current - 1, true);
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (nextBtn.disabled) return;
      if (current === total - 1) {
        showResults();
      } else {
        showQuestion(current + 1, true);
      }
    });
    if (restartBtn) restartBtn.addEventListener('click', restart);

    // --- 7-day plan capture: send via the worker instead of the plain
    // newsletter POST when an endpoint is configured -------------------------
    var emailForm = email ? email.querySelector('form') : null;
    if (emailForm && planEndpoint) {
      emailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = emailForm.querySelector('input[type="email"]');
        var value = (input && input.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) { planMsg(planErrorMsg, false); return; }
        var submit = emailForm.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        fetch(planEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ email: value, pattern: lastWinner || 'n', locale: document.documentElement.lang || 'pl' })
        }).then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('http ' + r.status)); })
          .then(function (d) {
            if (!d || d.ok === false) throw new Error('failed');
            var row = emailForm.querySelector('.newsletter-row');
            if (row) row.style.display = 'none';
            planMsg(planSuccessMsg, true);
          })
          .catch(function () {
            planMsg(planErrorMsg, false);
            if (submit) submit.disabled = false;
          });
      });
    }
    function planMsg(text, ok) {
      if (!emailForm) return;
      var m = emailForm.querySelector('.newsletter-message');
      if (!m) {
        m = document.createElement('p');
        m.className = 'newsletter-message';
        var row = emailForm.querySelector('.newsletter-row');
        if (row && row.parentNode) row.parentNode.insertBefore(m, row.nextSibling);
        else emailForm.appendChild(m);
      }
      m.classList.toggle('newsletter-message--success', ok);
      m.classList.toggle('newsletter-message--error', !ok);
      m.textContent = text;
    }
  }

  function initAll() {
    document.querySelectorAll('[data-quiz]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) e.target.querySelectorAll('[data-quiz]').forEach(init);
  });
})();
